// extracted by mini-css-extract-plugin
export default {"img":"Homepage_img__uYfr-","fadeInAnimation":"Homepage_fadeInAnimation__3QSBe","show":"Homepage_show__nTqmP","mask":"Homepage_mask__uiczu"};